import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import apiClient from '../utils/apiClient';
import './LastAnalysisBanner.css';

const LastAnalysisBanner = ({ onOpenAnalysis }) => {
  const { t } = useTranslation();
  const [lastAnalysis, setLastAnalysis] = useState(null);

  useEffect(() => {
    const loadLastAnalysis = async () => {
      try {
        const response = await apiClient.get('/session/impact-radar');
        const data = response?.data ?? response;

        const foundNodesCount = (Array.isArray(data?.impactedNodes) ? data.impactedNodes.length : 0)
          || data?.nodeCount
          || data?.nodesCount
          || 0;

        if (data && foundNodesCount > 0) {
          setLastAnalysis(data);
        } else {
          setLastAnalysis(null);
        }
      } catch (err) {
        setLastAnalysis(null);
      }
    };

    loadLastAnalysis();
  }, []);

  const nodesCount = (Array.isArray(lastAnalysis?.impactedNodes) ? lastAnalysis.impactedNodes.length : 0)
    || lastAnalysis?.nodeCount
    || lastAnalysis?.nodesCount
    || 0;

  if (!lastAnalysis || nodesCount <= 0) {
    return null;
  }

  return (
    <div className="analysis-banner-wrapper mb-6">
      <div className="analysis-banner-container">
        <div className="analysis-banner-content">
          {/* Left Section: Icon + Title */}
          <div className="analysis-banner-left">
            <div className="analysis-icon-small">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <h3 className="analysis-title-compact">{t('impactRadar.lastAnalysisSection.title')}</h3>
          </div>

          {/* Right Section: Node + Stats */}
          <div className="analysis-info-compact">
            {lastAnalysis?.impactedNodes?.[0]?.name && (
              <span className="analyzed-node-name">
                📌 {lastAnalysis.impactedNodes[0].name}
              </span>
            )}
            <div className="analysis-stats-compact">
              <span className="stat-badge-compact stat-badge-blue-compact">
                <strong>{nodesCount}</strong> {t('impactRadar.lastAnalysisSection.nodesLabel')}
              </span>
              <span className="stat-badge-compact stat-badge-orange-compact">
                <strong>{lastAnalysis.riskScore || 0}%</strong> {t('impactRadar.lastAnalysisSection.riskLabel')}
              </span>
              {lastAnalysis.confidenceScore != null && (
                <span className="stat-badge-compact stat-badge-green-compact">
                  <strong>{lastAnalysis.confidenceScore}%</strong> {t('impactRadar.lastAnalysisSection.confidenceLabel')}
                </span>
              )}
            </div>
          </div>

          {/* Right Section: Actions */}
          <div className="analysis-banner-actions-compact">
            <button
              onClick={() => {
                if (onOpenAnalysis) {
                  onOpenAnalysis(lastAnalysis);
                }
              }}
              className="analysis-btn-primary-compact"
              title={t('impactRadar.lastAnalysisSection.button')}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <span>{t('impactRadar.lastAnalysisSection.button')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LastAnalysisBanner;